import { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { ArrowLeft, Plus } from "lucide-react";
import { comparePassword } from "../../utils/hashPassword"; // Import the utility

export default function Obras() {
   const [editRecord, setEditRecord] = useState({ usuario: "", password: "" });
   const [showModal, setShowModal] = useState(true);
   const [isAuthenticated, setIsAuthenticated] = useState(false);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState("");
   const navigate = useNavigate();
   const adminUser = localStorage.getItem("adminUser");

   // Check if user is already authenticated
   useEffect(() => {
      const authStatus = localStorage.getItem("adminAuthenticated");
      if (authStatus === "true") {
         setIsAuthenticated(true);
         setShowModal(false);
      }
   }, []);

   const handleSave = async () => {
      setLoading(true);
      setError("");

      try {
         // Fetch user from database
         const { data: users, error: fetchError } = await supabase
            .from("admin_users") // Assuming you have an admin_users table
            .select("*")
            .select("*")
            .eq("usuario", editRecord.usuario)
            .single();

         if (fetchError || !users) {
            setError("Usuario no encontrado");
            setLoading(false);
            return;
         }
         console.log("users: ", users);

         // Compare password with hashed password
         const isValidPassword = await comparePassword(
            editRecord.password,
            users.password_hash
         );

         if (isValidPassword) {
            // Authentication successful
            setIsAuthenticated(true);
            setShowModal(false);
            localStorage.setItem("adminAuthenticated", "true");
            localStorage.setItem("adminUser", editRecord.usuario);
            console.log("Login successful");
         } else {
            setError("Contraseña incorrecta");
         }
      } catch (err) {
         console.error("Authentication error:", err);
         setError("Error de autenticación");
      }

      setLoading(false);
   };
   

   const handleLogout = () => {
      setIsAuthenticated(false);
      setShowModal(true);
      setEditRecord({ usuario: "", password: "" });
      localStorage.removeItem("adminAuthenticated");
      localStorage.removeItem("adminUser");
      navigate("/");
   };

   return (
      <div className="md:p-6 text-center">
         <h1 className="text-3xl font-bold">Administración</h1>
         <div className="flex flex-col md:flex-row min-h-screen">
            {/* Menú lateral */}
            <aside className="w-full md:w-64 bg-white border-r border-gray-300">
               <h2 className="text-lg font-bold text-gray-800 p-4">Opciones</h2>
               <nav className="space-y-2 px-4">
                  <Link
                     to="usuarios"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Clientes
                  </Link>
                  <Link
                     to="obrasadm"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Obras
                  </Link>
                  <Link
                     to="muestrasadm"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Muestras
                  </Link>
                  <Link
                     to="pedidos"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Pedidos
                  </Link>
                  <Link
                     to="cotizacionadmin"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Cotizaciones
                  </Link>
                  <Link
                     to="contactoadm"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Contactos
                  </Link>
                  <hr />
                  <Link
                     to="estadistica"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Estadisticas
                  </Link>
                  <hr />
                  <Link
                     to="Tablas"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Tablas
                  </Link>
                  <Link
                     to="administradores"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Administradores
                  </Link>
                  <Link
                     to="/"
                     className="block px-4 py-2 rounded hover:bg-gray-100 text-gray-800"
                  >
                     Volver
                  </Link>
                           {/* Add logout button to sidebar when authenticated */}
         {isAuthenticated && (
            <div className="mt-auto p-4">
               <button
                  onClick={handleLogout}
                  className="w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
               >
                  Cerrar Sesión
               </button>
               <p className="text-sm text-gray-600 mt-2">
                 Usuario: <b>{adminUser}</b>
               </p>
            </div>
         )}
               </nav>
            </aside>

            {/* Contenido dinámico */}
            <main className="flex-1 p-6">
               <Outlet />
            </main>
         </div>

         {/* Modal */}
         {showModal && !isAuthenticated && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
               <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                  <h2 className="text-xl font-bold mb-4">
                     Acceso Administrativo
                  </h2>

                  {error && (
                     <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                        {error}
                     </div>
                  )}

                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-32">
                        Usuario
                     </label>
                     <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.usuario}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              usuario: e.target.value,
                           })
                        }
                        disabled={loading}
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-32">
                        Contraseña
                     </label>
                     <input
                        type="password"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.password}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              password: e.target.value,
                           })
                        }
                        disabled={loading}
                        onKeyPress={(e) => {
                           if (e.key === "Enter") {
                              handleSave();
                           }
                        }}
                     />
                  </div>

                  <div className="flex justify-end gap-3">
                     <Link to="/" className="btn-gray-light">
                        <ArrowLeft className="lucid-icons" /> Cancelar
                     </Link>
                     <button
                        onClick={handleSave}
                        className="btn-green"
                        disabled={
                           loading ||
                           !editRecord.usuario ||
                           !editRecord.password
                        }
                     >
                        {loading ? (
                           <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                        ) : (
                           <>
                              <Plus className="lucid-icons-blue" /> Ingresar
                           </>
                        )}
                     </button>
                  </div>
               </div>
            </div>
         )}


      </div>
   );
}
